import React, { useEffect, useState } from "react";
// import styles from "../eddie-paredes/teachers.module.css";
import styles from "./divine-manifestation.module.css";

import { Box, Link, Modal, Typography, useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Common_html from "./components/Common_html";
import BlockData from "../../divine-manifestation-json/divine-manifestation.json";
import Image from "next/image";
import Head from "next/head";
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";

export default function Index() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [showOtherBlocks, setShowOtherBlocks] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOtherBlocks(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:601px) and (max-width:900px)");

  let logoBanner = "/image/logobanner_desktop.webp";

  if (isMobile) {
    logoBanner = "/image/logobanner.webp";
  } else if (isTablet) {
    logoBanner = "/image/logobanner.webp";
  }
  return (
    <>
      <Head>
        <title>
          Astrological Theurgy & Divine Manifestation of the Future | School of Our Divine Infinite Being
        </title>
        <meta name="robots" content="index, follow"></meta>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Eddie Paredes, founder, biography, spiritual teacher, Divine Theurgy, Polytheistic Monism, Theurgist, Divine Infinite Being, Self Realization"
        ></meta>
        <meta
          name="description"
          content="Discover the life and journey of Eddie Paredes, the founder of the School of Our Divine Infinite Being. Explore his background, spiritual path, and the vision that led to our unique approach to Theurgy."
        ></meta>

        <meta
          name="author"
          content="School of Our Divine Infinite Being"
        ></meta>
        <meta
          name="subject"
          content="Astrological Theurgy, Ritual Praxis, and Divine Manifestation"
        ></meta>

        <meta name="language" content="English"></meta>
        <meta name="geo.region" content="US"></meta>

        <meta
          property="og:title"
          content="Astrological Theurgy & Divine Manifestation of the Future | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/eddie_paredes_bio_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="A portrait of Eddie Paredes, founder of the School of Our Divine Infinite Being"
        ></meta>
        <meta
          property="og:description"
          content="Explore how Astrological Theurgy aligns the soul with cosmic order, allowing theurgists to participate in divine manifestation and shape the living continuum of the future."
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/eddie_paredes_bio_og_img.webp"
        ></meta>
        <meta
          property="twitter:title"
          content="Astrological Theurgy & Divine Manifestation of the Future"
        ></meta>
        <meta
          property="twitter:url"
          content="https://www.divineinfinitebeing.com/divine-manifestation"
        ></meta>
        <meta
          property="twitter:description"
          content="Learn how theurgic practice and cosmic alignment open the path to divine manifestation and the shaping of future realities."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/divine-manifestation"
        ></meta>

        <link
          rel="canonical"
          href="https://www.divineinfinitebeing.com/divine-manifestation"
        />
      </Head>

      {/* <div className={styles.rotathewheelblockone}>
        
        <div className={styles.asmainwrapper}>
          <div className={styles.rotathewheelblockoneleft}>
            <div className={styles.bannerLogo}>
              <span className={styles.logoviewlink} onClick={handleOpen}>
                <Image
                  src="/image/viewicon.webp"
                  alt="View Icon"
                  width={400}
                  height={100}
                  style={{ width: "100%", height: "auto" }}
                  priority={true}
                  placeholder="blur"
                  blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                />
              </span>
              <Image
                src="/image/logobanner_cropped.webp"
                alt="School of Our Divine Infinite Being Logo"
                width={332}
                height={332}
                style={{ width: "100%", height: "auto" }}
                priority={true}
                placeholder="blur"
                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
              />
            </div>
            <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
            <h1 data-text="infinite being">INFINITE BEING</h1>

            <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
            <div
              className={`${styles.rotathewheelbottombannerbg} ${styles.bannerboxtxt}`}
            >
              <div className={styles.yellow_bar}></div>
            </div>
          </div>
        </div>
      </div> */}

      <div className={styles.divine_manifestation_block_1}>
                    <div className={styles.divine_manifestation_banner_main_wrpr}>
                        <div className={styles.divine_manifestation_banner_left}>
                            <div className={styles.bannerLogo}>
                                <span className={styles.logoviewlink} onClick={handleOpen}>
                                    <Image
                                        src="/image/viewicon.webp"
                                        alt="View Icon"
                                        width={400}
                                        height={100}
                                        style={{ width: "100%", height: "auto" }}
                                        priority={true}
                                        placeholder="blur"
                                        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                                    />
                                </span>
                                <Image
                                    src="/image/logobanner_cropped.webp"
                                    alt="School of Our Divine Infinite Being Logo"
                                    width={332}
                                    height={332}
                                    style={{ width: "100%", height: "auto" }}
                                    priority={true}
                                    placeholder="blur"
                                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                                />
                            </div>
                            <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
                            <h1 data-text="infinite being">INFINITE BEING</h1>

                            <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
                            <div
                                className={`${styles.divine_manifestation_bottombannerbg} ${styles.bannerboxtxt}`}
                            >
                                <div className={styles.yellow_bar}></div>
                            </div>
                        </div>
                    </div>
                </div>

      <MysteryBannerNew />          

      <Common_html BlockData={BlockData} />
      {/* -----------------------------------------modal---------------------------------- */}
      {showOtherBlocks && (
        <>
          {/* ===================== Chapters end=============== */}

          {/* ==================== modal =================== */}
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="banner_modal_main"
          >
            <Box className="banner_modal_box">
              <Typography
                id="modal-modal-description"
                sx={{ mt: 2 }}
                className="modal_banner"
                component="div"
              >
                <div className="sub_modal_banner">
                  <span className="close_btn" onClick={handleClose}>
                    <CloseIcon />
                  </span>

                  <Image
                    src={logoBanner}
                    alt="bannerLogo"
                    width={400}
                    height={100}
                    style={{ width: "100%", height: "100%" }}
                    priority={false}
                    placeholder="blur"
                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUA"
                  />
                </div>
              </Typography>
            </Box>
          </Modal>
        </>
      )}
    </>
  );
}
